import { Divider } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import ArrowDropDownOutlinedIcon from '@material-ui/icons/ArrowDropDownOutlined'
import CreateIcon from '@material-ui/icons/Create'
import AppContext from 'containers/App/Store/AppContext'
import React, { useContext } from 'react'
import BlackDollarIcon from '../../assets/icons/Money/black-dollar.svg'
import { useNumberFormatter } from '../../helpers/Hooks/useNumberFormatter'
import IconText from '../Typography/IconText'

interface subHeaderProps {
  title?: any
  rightText?: any
  rightTextIsMoney?: boolean
  infoLine?: any
  rightInfoLine?: any
  dropDownOptions?: any
  infoLineDropDownOptions?: any
  handleClick?: any
  noIconHandleClick?: boolean
  infoLineHandleClick?: any
  // fixResponsive?: boolean //new changes 5/6/2021 by syafiq ali
  isPicture?: any //new changes 5/6/2021 by syafiq ali
  style?: any
  infoLineStyle?: any
  rightInfoLineStyle?: any
  cutomizedSubheaderStyle?: any
  rightIcon?: any
}

const DynamicSubHeader = ({
  infoLine,
  infoLineStyle,
  rightInfoLineStyle,
  rightText,
  rightTextIsMoney,
  title,
  dropDownOptions,
  infoLineDropDownOptions,
  handleClick,
  noIconHandleClick,
  infoLineHandleClick,
  rightInfoLine,
  style,
  cutomizedSubheaderStyle,
  // fixResponsive, //new changes 5/6/2021 by syafiq ali
  isPicture,
  rightIcon,
}: subHeaderProps) => {
  const { globalState }: any = useContext(AppContext as any)
  const { amountFormatter }: any = useNumberFormatter()

  return (
    //new changes 5/6/2021 by syafiq ali
    <div
      className={`fix-subheader${globalState.drawerOpen ? '' : '-fw'}`}
      style={style}
    >
      {/* //new changes 5/6/2021 by syafiq ali */}
      <div
        className={`dynamic-subheader fix-subheader-content 
         ${(infoLine || rightInfoLine)  ? 'multiple' : 'single'} `}
        style={cutomizedSubheaderStyle}
      >
        {isPicture} {/* //new changes 5/6/2021 by syafiq ali */}
        <div className={`${isPicture && 'wraps-dynamic-content'}`}>
          <div className="dynamic-content" onClick={handleClick}>
            <div className="session flex">
              <div className="xsTitle flex-space c-orange text-overflow">
                {title}
              </div>
              {rightText >= 0 && rightTextIsMoney ? (
                <div className="xsTitle rightText">
                  <IconText
                    icon={
                      <img src={BlackDollarIcon} style={{ width: '12px' }} />
                    }
                    font="xsTitle"
                    children={amountFormatter(rightText)}
                  />
                </div>
              ) : (
                rightText && (
                  <div className="xsTitle rightText">{rightText}</div>
                )
              )}
              {dropDownOptions ? (
                <IconButton className="right-btn" style={{ padding: 0 }}>
                  <ArrowDropDownOutlinedIcon />
                </IconButton>
              ) : !!handleClick && noIconHandleClick ? null : !!handleClick ? (
                <IconButton className="right-btn" style={{ padding: 0 }}>
                  <CreateIcon />
                </IconButton>
              ) : null}
            </div>
          </div>
          <Divider style={{ backgroundColor: '#fff' }} />
          <div className="infoline-content" onClick={infoLineHandleClick}>
            <div className="infoline flex-space" style={infoLineStyle}>
              {infoLine}
            </div>
            {infoLineDropDownOptions ? (
              <IconButton className="right-btn" style={{ padding: 0 }}>
                <ArrowDropDownOutlinedIcon />
              </IconButton>
            ) : null}
            <div
              className="infoline rightText"
              style={
                !!dropDownOptions && !!rightInfoLine
                  ? { paddingRight: '25px', ...rightInfoLineStyle }
                  : rightInfoLineStyle
              }
            >
              {rightInfoLine}
            </div>
          </div>
        </div>
        {dropDownOptions}
        {infoLineDropDownOptions}
      </div>
    </div>
  )
}

export default DynamicSubHeader
